import React from 'react'
import ClearIcon from '@material-ui/icons/Clear'
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core'
import { Button } from '@resiliatech/birdsong'
import useStyles from './styles'

type Props = {
  onCancelHandler: () => void
  onSubmitHandler: () => void
  open: boolean
  submitButtonText: string
  title: string
}

const ConfirmActionDialogSong: React.FC<Props> = ({
  children,
  onCancelHandler,
  onSubmitHandler,
  open,
  submitButtonText,
  title,
}) => {
  const classes = useStyles()
  return (
    <Dialog open={open} onClose={onCancelHandler} maxWidth='xl'>
      {onCancelHandler && (
        <Button onClick={onCancelHandler} className={classes.closeButton}>
          <ClearIcon />
        </Button>
      )}
      <DialogTitle>
        <Box display='flex' justifyContent='center' textAlign='center'>
          <Typography variant='h4' className={classes.bold}>
            {title}
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box width='100%' className={classes.content}>
          {children}
        </Box>
      </DialogContent>
      <DialogActions>
        <Box
          display='flex'
          justifyContent='space-evenly'
          padding='20px'
          width='100%'
        >
          <Button
            data-testid='cancelAction'
            label='Cancel'
            onClick={onCancelHandler}
            variant='tertiary'
          />
          <Button
            data-testid='confirmAction'
            label={submitButtonText}
            onClick={onSubmitHandler}
            variant='primary'
          />
        </Box>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmActionDialogSong
